// annotation_frontend\src\pages\AdminPage.js
import React from 'react';
import { Box, Typography, Paper, Divider } from '@mui/material';
import BulkUpload from '../components/admin/BulkUpload';
import ExportData from '../components/admin/ExportData';
import AdminValidationViewer from '../components/admin/AdminValidationViewer'; // Import the new component

const AdminPage = () => {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Typography variant="h4" gutterBottom>Admin Dashboard</Typography>

      {/* Section 1: Data Management */}
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h5" gutterBottom>Data Management</Typography>
        <BulkUpload />
        <Divider sx={{ my: 3 }} />
        <ExportData />
      </Paper>

      {/* Section 2: Validation */}
      <Paper sx={{ p: 3, mb: 3 }}>
        {/* Replace placeholder with the actual validation component */}
        <AdminValidationViewer />
      </Paper>

      {/* Section 3: User Activity */}
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h5" gutterBottom>User Activity</Typography>
        <Typography variant="body1">
          View user rankings and statistics on the <a href="/rankings">Rankings Page</a>.
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          Additional user management features could be added here if needed (e.g., view user roles - though roles are currently based on LDAP/config).
        </Typography>
      </Paper>

    </Box>
  );
};

export default AdminPage;